import Cookies from 'js-cookie';

export const clearCookiesExceptTrustedDevice = (): void => {
  const allCookies = Cookies.get();

  Object.keys(allCookies).forEach((cookieName) => {
    if (cookieName.includes('trusted_device')) {
      return;
    }

    Cookies.remove(cookieName, { path : '/', domain : '.ingresse.com' });
    Cookies.remove(cookieName, { path : '/' });
    Cookies.remove(cookieName);
  });
};
